<template>
  <div class="evaluation-component">

    <!-- 评分区域 -->
    <div class="rate-section">
      <span>请打分：</span>
      <van-rate
        v-model="formData.rating"
        :size="30"
        color="#ffd21e"
        void-icon="star"
        void-color="#eee"
        allow-half
        :readonly="isPj"
        @change="onRatingChange"
      />
      <span class="rating-text">{{ displayRating }}</span>
    </div>
    
    <!-- 评价内容输入框 -->
    <van-field
      v-model="formData.content"
      rows="5"
      autosize
      type="textarea"
      maxlength="500"
      placeholder="请详细描述您的使用体验或建议..."
      show-word-limit
      :readonly="isPj"
      class="content-field"
    />

    <!-- 提交按钮 -->
    <van-button 
      type="primary" 
      block 
      :disabled="!isFormValid || isPj" 
      @click="handleSubmit"
      class="submit-btn"
    >
      提交评价
    </van-button>
  </div>
</template>
<script>
import { Rate, Field, Button, Toast } from 'vant';
import api from '@/utils/api';

export default {
  name: 'EvaluationForm',
  components: {
    [Rate.name]: Rate,
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
      formData: {
        content: '', // 评价内容
        rating: 0    // 评分值
      },
      isPj: false,
      hasRate:false,
      isSubmitting: false // 防止重复提交
    };
  },
  computed: {
    // 控制提交按钮是否可用的计算属性
    isFormValid() {
      return this.formData.rating > 0 && !this.isSubmitting;
    },
    // 用于友好显示当前评分
    displayRating() {
      return this.formData.rating > 0 ? `${this.formData.rating}分` : '暂无评分';
    }
  },
  methods: {
    // 评分变化时的回调
    onRatingChange(value) {
      console.log('当前评分：', value);
      // 这里可以根据评分值做一些即时反馈，比如改变提示语
    },
    
    // 提交评价
    async handleSubmit() {
      const that = this;
      // 验证表单
      // 再次验证
      if (!that.isFormValid) {
        Toast('请完成评分后再提交');
        return;
      }
      that.isSubmitting = true;
      try {
        // 构造提交数据
        const data ={
          "evaluation_context": that.content,
          "rating": that.rating
        };
        api.post('/v1/evaluation',data)
          .then(response => {
            if(response.data.code === 0){
                that.$toast('评价提交成功！');
                that.isFormValid = true;
                that.isPj = true;
                //that.resetForm(); // 重置表单
                //this.$emit('submit-success', submitData); // 通知父组件
            }else{
              //失败
              that.$toast(response.data.msg);
            }
          })
          .catch(error => {
            that.$toast('请求失败:'+ error);
          });

        // 模拟API调用，替换为你的实际接口
        // await this.$api.evaluation.submit(submitData);
        // await new Promise(resolve => setTimeout(resolve, 1000)); // 模拟网络请求
        // Toast.success('评价提交成功！');
        // this.resetForm(); // 重置表单

      } catch (error) {
          // 可以根据错误状态码进行更细致的处理
        if (error.response && error.response.status === 404) {
          that.errorMessage = '请求的资源不存在。';
          that.$toast('请求的资源不存在。,请刷新后重试');
        }else{
          that.$toast('调用接口出错,请刷新后重试');
        }
      } finally {
        this.isSubmitting = false;
      }
    },

    // 重置表单
    resetForm() {
      this.formData = {
        content: '',
        rating: 0
      };
    }
  }
};
</script>
<style scoped>
.evaluation-component {
    
  margin: 15px;
  border-radius: 24px;
  padding: 20px;
  background: #fff;
}

.content-field {
  margin-bottom: 25px;
  border: 1px solid #ebedf0;
  border-radius: 6px;
  padding: 10px;
}

.rate-section {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding: 10px 0;
  font-size: 16px;
}

.rating-text {
  margin-left: 10px;
  color: #f44;
  font-weight: bold;
}

.submit-btn {
  border-radius: 6px;
}
</style>